export default "__VITE_ASSET__35f968ce__"